import { Field } from 'react-final-form';
import React from 'react';
import { Grid, IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { TextField } from 'final-form-material-ui';
import required from '../validators/required';

const AttendeeDetails = ({ name, index, total, onDelete }) => (

  <Grid container alignItems="flex-start" spacing={8} style={{marginTop: 16}}>
    <Grid item xs={total > 1 ? 11 : 12}>
      <h4 style={{marginBottom: 5}}>{`Attendee ${index + 1}`}</h4>
      <Field
        fullWidth
        required
        name={`${name}.Name`}
        component={TextField}
        type="text"
        label='Name'
        validate={required}
      />
    </Grid>
    {
      total > 1 && <Grid item xs={1} style={{paddingTop: 15}}>
        <IconButton aria-label="Delete" onClick={onDelete}><DeleteIcon /></IconButton>
      </Grid>
    }

    <Grid item xs={12}>
      <Field
        fullWidth
        name={`${name}.DietaryRequirements`}
        component={TextField}
        type="text"
        label="Dietary requirements"
      />
    </Grid>

    <Grid item xs={12}>
      <Field
        fullWidth
        name={`${name}.Email`}
        component={TextField}
        type="email"
        label="Email"
      />
    </Grid>
  </Grid>
);

export default AttendeeDetails;
